import { OperationState, TaskStatus, getIconClassFromTaskStatus, getIconTitleForIconClass } from "./task";

export class Job {
    availableThreads: number;
    calendarDuration: string;
    currentRate: number;
    description: string;
    desiredRate: number;
    estimatedCompletionTime: string;
    expressNodeCapable: boolean;
    extendedStatus: string;
    handle: string;
    name: string;
    numberNodes: number;
    numberResults: number;
    numberThreads: number;
    organization: string;
    percentComplete: any;
    priority: string;
    processingDuration: string;
    projectName: string;
    projectDescription: string;
    serviceName: string;
    stErrorCode: string;
    startTime: string;
    state: string;
    status: string;
    submitTime: string;
    type: string;
    userName: string;

    totalCores: number;
    iconClass: string;
    tooltip: string;
    projectNameDescription: string;
    originalDesiredRate: string = null;
    operationState: string;
    taskStatus: string;
    hasDisabledContextMenu = false;
    rateHasChanged = false;

    constructor(value?: Partial<Job>) {
        if (value) {
            value.iconClass = getIconClassFromTaskStatus(value.status as TaskStatus, value.state as OperationState);
            value.tooltip = getIconTitleForIconClass(value.iconClass, value.state as OperationState);

            if (value.priority) {
                value.priority = value.priority.charAt(0).toUpperCase() + value.priority.slice(1).toLowerCase();
            }

            if (value.processingDuration === 'N/A') {
                value.processingDuration = timeConvert(value.startTime);
            }

            if (value)
                Object.assign(this, value);
            this.operationState = value.state;
            this.taskStatus = value.status;
            this.projectNameDescription = this.projectDescription ? `${this.projectName} - ${this.projectDescription}` : this.projectName;
        }
    }
}

function timeConvert(startDate) {
    const start: any = new Date(startDate);
    const today: any = new Date();
    const hours = Math.abs(today - start) / 36e5;
    const rhours = Math.floor(hours);
    const rminutes = Math.round((hours - rhours) * 60);
    return rhours.toString() + ':' + rminutes.toString() + ':' + '00';
}


export class StatusManagementContext {
    requestInfoData: any;
    preselectedStatusType: string;

    constructor(value?: Partial<StatusManagementContext>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}